export default "__VITE_ASSET__BAwTk77___"